<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Create/Connect Model</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="create/connect model" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Model Name</label>
                <select v-model="selectedModel">
                    <option value="">Select Model</option>
                    <option v-for="model in props.models" :key="model.id" :value="model.name">
                        {{ model.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Template Name</label>
                <select v-model="templateName">
                    <option value="">Select Template</option>
                    <option value="template 1">template 1</option>
                    <option value="template 2">template 2</option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createConnectModelWorkflowItem } from '../utils/workflowUtils';

const props = defineProps({
    models: Array
});

const actionName = ref('');
const selectedModel = ref('');
const templateName = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createConnectModelWorkflowItem(
        actionName.value,
        selectedModel.value,
        templateName.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
